export default __webpack_public_path__ + "media/images/happy-dog-decor-2-f99b71ab0ff49b86eb232947207b8823.png";